<template>
    <div class="header-component">
        <div class="component-title-box">
            <component-title
                :config="config">
            </component-title>
            <div class="header-component-components">
                <template v-for="(component) in getComponents">
                    <component
                        :is="loadComponent(component.type)"
                        :config="component.config"
                        :eventBus="$root"
                        :routeParams="routeParams"
                        :moduleName="moduleName"
                    ></component>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import ComponentTitle from "@/components/ComponentTitle.vue";

    export default {
        components: {ComponentTitle},
        props: {
            config: {
                Type: Object,
                default: function () {
                    return {
                        title: null,
                        index: null,
                        description: null,
                        emitEvents: {}
                    }
                }
            },
            eventBus: {
                Type: Object,
            },
            routeParams: {
                Type: Object
            },
            moduleName: {
                Type: String,
            },
        },
        data() {
            return {
                componentIndex: null,
                components: [],
            }
        },
        inject: ['eventManager'],
        mounted() {
            this.init();
            this.mountEvents();
            this.eventManager.emitEvents(this.config.emitEvents['mounted'] || [], []);
        },
        beforeUpdate() {
        },
        methods: {
            init() {
                this.componentIndex = this.config.index;
                this.components = this.config.components;
            },
            mountEvents() {
                this.eventManager.bindEvents(this.defaultBindEvents(), this);
            },
            unmountEvents() {
                this.eventManager.unbindEvents(this.defaultBindEvents());
            },
            defaultBindEvents() {
                return [];
            },
            loadComponent(type) {
                return require(`./${type}.vue`);
            },
        },
        computed: {
            getComponents() {
                return this.components.filter(c => c.config.display).sort((a, b) => a.config.position - b.config.position);
            },
        }
    }
</script>

<style lang="sass">
    .title {
        font-weight: bold;
    }
    .header-component {
        position: relative;
    }
    .header-component-components {
        position: absolute;
        top: 15px;
        right: 15px;
    }
    .header-component-components > div {
        float: right;
        margin-left: 3px;
    }
</style>



// WEBPACK FOOTER //
// HeaderComponent.vue?7d62606c